module.exports = __webpack_public_path__ + "static/media/purewatt-gb-4.8603666c.jpg";